module.exports = __webpack_public_path__ + "img/company_happytablebi.ce148048.png";